import { useEffect, useState } from 'react'
import { AuthProvider, AuthManager } from '@tomfxs/permissions-client'
import { ActorJSON } from '@tomfxs/permissions-core'
import loadComponent from 'src/utils/loadMFE'

import translations from './AuthTranslations.json'
import { useCookies } from 'react-cookie'

async function registerSources(manager: AuthManager) {
    await Promise.allSettled(
        ['orga', 'traiwiss', 'statistic', 'api_gateway', 'search', 'mfeedback'].map(async (ms) => {
            const source = (await loadComponent(ms, 'AuthSource')).default
            manager.registerSource(source)
        }),
    )
}

interface AuthenticationProviderProps {
    children: React.ReactNode
}

export function AuthenticationProvider({ children }: AuthenticationProviderProps) {
    const [manager] = useState(() => new AuthManager())

    useEffect(() => {
        registerSources(manager)
    }, [manager])
    const [cookies] = useCookies(['x-mp-auth'])
    const [actor, setActor] = useState<ActorJSON | undefined>(() =>
        cookies['x-mp-auth'] ? prepareActorCookie(cookies['x-mp-auth']) : undefined,
    )
    useEffect(() => {
        if (cookies['x-mp-auth']) {
            setActor(prepareActorCookie(cookies['x-mp-auth']))
        }
    }, [cookies])

    return (
        <AuthProvider manager={manager} t={t} tPrefix="auth" actor={actor}>
            {children}
        </AuthProvider>
    )
}
function prepareActorCookie(cookie: string) {
    const [, payload] = cookie.split('.')
    return JSON.parse(atob(payload)) as ActorJSON
}

function t(key: string, data: any | undefined) {
    if (/AUTH\..+\.DISPLAY/.test(key) && data) {
        const entityType = /AUTH\.(.+)\.DISPLAY/.exec(key)![1]

        switch (entityType) {
            default:
                return `${data.name}`
        }
    }

    const keyFragments = key.split('.')
    let translation: any = translations

    for (const fragment of keyFragments) {
        translation = translation[fragment]

        if (!translation) return key
    }

    return translation
}
